export default () => `
<!-----------------footer------------------------>
<div class="footer1">
    <div class="container1">
        <div class="row1">
            <div class="footer-col-4">
                <h3>HELP</h3>
                <ul>
                    <li>Contact Us</li>
                    <li>Shipping</li>
                    <li>Return</li>
                    <li>FAQ</li>
                </ul>
            </div>

            <div class="footer-col-4">
                <h3>CUSTOMER SERVICE</h3>
                <ul>
                    <li><a href="/OrderStatus" class="order-status" data-navigo>Order Status</a></li>
                    <li>Track My Order</li>
                    <li>Return My Order</li>
                    <li>Contact Us</li>
                </ul>
            </div>
            <div class="footer-col-2">
                <div>
                    <img src="https://github.com/asmita85/Capstone/blob/master/images/header/finallogo.png?raw=true">
                </div>
                <div>
                <a> </a>
                </div>
            </div>
            <div class="footer-col-1">
                <h3>Our App</h3>
                <p>download app for android and ios</p>
                <div class="app-logo">
                    <a href=""><img src="https://github.com/asmita85/Capstone/blob/master/images/footer/apple.png?raw=true" alt=""></a>
                    <a href=""><img src="https://github.com/asmita85/Capstone/blob/master/images/footer/google.png?raw=true" alt=""></a>
                </div>
            </div>
            <div class="small-container">
                <div class="row1">
                    <div class="col-5">
                        <img src="https://github.com/asmita85/Capstone/blob/master/images/footer/Americanexpress.png?raw=true">
                    </div>
                    <div class="col-5">
                        <img src="https://github.com/asmita85/Capstone/blob/master/images/footer/discover.png?raw=true">
                    </div>
                    <div class="col-5">
                        <img src="https://github.com/asmita85/Capstone/blob/master/images/footer/Mastercard.png?raw=true">
                    </div>
                    <div class="col-5">
                        <img src="https://github.com/asmita85/Capstone/blob/master/images/footer/visa.png?raw=true">
                    </div>
                    <div class="col-5">
                        <img src="https://github.com/asmita85/Capstone/blob/master/images/footer/paypal.png?raw=true">
                    </div>
                </div>
            </div>
        </div>
        <hr>
    </div>
    <p class="copyright">copyright 2020 - EzShop</p>
</div>
`;
